import { I18n } from 'react-redux-i18n';
import { Modal, ModalFooter, ModalTitle, ModalBody, ModalHeader } from '@common/components/modal';
import { getTestAttributes } from '@common/utils/tests';
import { Flex } from '@common/components/Flex';
import { Button } from '@common/components/Button';
import { FormControl } from '@common/components/form-control';

import { MODULE_NAME } from '@modules/individuals';

import './individual-renaming.styles.scss';

export const IndividualRenaming = (props) => {
  const localModuleName = `${MODULE_NAME}-renaming-individual-modal`;
  const { onClose, onSubmit, showErrorMessage, defaultValue } = props;
  const [value, setValue] = React.useState('');
  const [submitting, setSubmitting] = React.useState(false);

  const handleChange = React.useCallback((e) => {
    setValue(e.target.value);
  }, []);

  const handleSubmit = React.useCallback(async () => {
    setSubmitting(true);

    try {
      await onSubmit(value);
    } catch (err) {
      setSubmitting(false);
      showErrorMessage(err?.entity || I18n.t('Failed to rename individual'));
      console.error(err);
    }
  }, [value, onSubmit, showErrorMessage]);

  return (
    <Modal 
      show
      animation={false}
      bsSize="medium"
      backdrop="static"
      bsClass="bootstrap modal"
      className="IndividualsIndividualRenaming"
      onEscapeKeyDown={onClose}
      onHide={onClose}
    >
      <ModalHeader closeButton onHide={onClose}>
        <ModalTitle className="IndividualsIndividualRenaming__title" {...getTestAttributes(localModuleName, 'header', 'title')} title={defaultValue}>
          {I18n.t('Rename Individual')} - {defaultValue}
        </ModalTitle>
      </ModalHeader>

      <ModalBody>
        <Flex justify="space-between" alignItems="center">
          <FormControl 
            placeholder={I18n.t('Type new individual name')}
            className="IndividualsIndividualRenaming__name-input"
            {...getTestAttributes(localModuleName, 'name', 'input')}
            onChange={handleChange}
          />
          <Button 
            className="IndividualsIndividualRenaming__submit-btn"
            disabled={!value.length || submitting}
            {...getTestAttributes(localModuleName, 'submit', 'button')}
            onClick={handleSubmit}
          >
            {submitting ? I18n.t('Loading') : I18n.t('Rename')}
          </Button>
        </Flex>
      </ModalBody>
    </Modal>
  );
};